// TODO: this will be re-organized and moved after the split
/**
 * This is important so that we don't get duplicates for things like the article
 * page therefore getting site.com/article/ instead of
 * site.com/article/123412312312
 * making it easier for our AdOps tools to agregate things out.
 **/
export function getTruncatedUrl() {
  const isV8ArticlePage = window.location.pathname.includes('/v8/article/')
  if (isV8ArticlePage) {
    return `https://${window.location.hostname}/v8/article/`
  }

  const isArticlePage = window.location.pathname.includes('/article/')
  if (isArticlePage) {
    return `https://${window.location.hostname}/article/`
  }

  return `https://${window.location.hostname}${window.location.pathname}`
}
